import ModalTextField from 'components/ModalTextField';
import TextFieldLabel from 'components/ModalTextField/textFieldLabel';
import { CalculateFieldNames } from 'utils/constants/fieldNames';
import InfoGreyIcon from 'assets/icons/info-grey.svg';
import { OperationalEfficiencySectionProps } from 'interfaces/components/dataEntryModal/OperationalEfficiencySection';
import {
  burnMultipleField,
  cacPaybackField,
  gaPercentOpexBaseField,
  netMagicNumberField,
  rdPercentOpexBaseField,
  smPercentOpexBaseField
} from 'utils/constants/fields';

const OperationalEfficiencySection = ({
  operationalEfficiencyParentRef,
  operationalEfficiencyRef,
  burnMultiple,
  onBurnMultipleChange,
  fcfMargin,
  netMagicNumber,
  onNetMagicNumberChange,
  revenue,
  gA,
  onGAChange,
  gaPercent,
  onGAPercentChange,
  sM,
  onSMChange,
  smPercent,
  onSMPercentChange,
  rD,
  onRDChange,
  rdPercent,
  onRDPercentChange,
  CACPaybackPeriod,
  onCACPaybackPeriodChange,
  handleCalculateBtnClick
}: OperationalEfficiencySectionProps) => {
  return (
    <div className='w-full' ref={operationalEfficiencyParentRef}>
      <div
        className='w-full flex flex-col items-start gap-4 scroll-mt-3'
        ref={operationalEfficiencyRef}
      >
        <p className='text-[24px] leading-[19.2px] font-light'>
          Operational Efficiency
        </p>
        <div className='w-full flex gap-4 items-start'>
          <ModalTextField
            {...burnMultipleField}
            value={burnMultiple ? burnMultiple : ''}
            onChange={onBurnMultipleChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.BURN_MULTIPLE)
            }
            disabled={
              !!fcfMargin && !isNaN(Number(fcfMargin)) && Number(fcfMargin) > 0
            }
          />
          <ModalTextField
            {...netMagicNumberField}
            value={netMagicNumber ? netMagicNumber : ''}
            onChange={onNetMagicNumberChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.NET_MAGIC_NUMBER)
            }
          />
        </div>
        <p className='text-[20px] leading-[19.2px] font-light'>
          OpEx Function as a % of Revenue
        </p>
        <div className='w-full grid grid-cols-2 gap-4'>
          <div className='flex flex-col gap-2'>
            <TextFieldLabel
              label='G&A'
              tooltip='Please enter the approximate % corresponding to your G&A operating expenses as a % of total revenue'
              name='gA'
            />
            <div className='flex gap-2'>
              <ModalTextField
                label='OpEx $'
                name='gA'
                value={gA ? gA : ''}
                onChange={onGAChange}
                character={revenue ? '$' : ''}
                isPrefixCharacter={!!revenue}
                isNumber
                placeholder={revenue ? '0' : 'N/A'}
                disabled={!revenue}
                infoIcon={InfoGreyIcon}
                showInfoIcon={!revenue}
                tooltipListTitle='Please enter Revenue in the Required Information to enter a $ amount for OpEx as a % of Revenue'
                labelStyle='text-gray-700'
                containerStyle='gap-[2px]'
                useCommaFormat={true}
              />
              <ModalTextField
                {...gaPercentOpexBaseField}
                label='% of Revenue'
                value={gaPercent ? gaPercent : ''}
                onChange={onGAPercentChange}
                labelStyle='text-gray-700'
                containerStyle='gap-[2px]'
              />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <TextFieldLabel
              label='S&M'
              tooltip='Please enter the approximate % corresponding to your S&M operating expenses as a % of total revenue'
              name='sM'
            />
            <div className='flex gap-2'>
              <ModalTextField
                label='OpEx $'
                name='sM'
                value={sM ? sM : ''}
                onChange={onSMChange}
                character={revenue ? '$' : ''}
                isPrefixCharacter={!!revenue}
                isNumber
                placeholder={revenue ? '0' : 'N/A'}
                disabled={!revenue}
                infoIcon={InfoGreyIcon}
                showInfoIcon={!revenue}
                tooltipListTitle='Please enter Revenue in the Required Information to enter a $ amount for OpEx as a % of Revenue'
                labelStyle='text-gray-700'
                containerStyle='gap-[2px]'
                useCommaFormat={true}
              />
              <ModalTextField
                {...smPercentOpexBaseField}
                label='% of Revenue'
                value={smPercent ? smPercent : ''}
                onChange={onSMPercentChange}
                labelStyle='text-gray-700'
                containerStyle='gap-[2px]'
              />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <TextFieldLabel
              label='R&D'
              tooltip='Please enter the approximate % corresponding to your R&D operating expenses as a % of total revenue'
              name='rD'
            />
            <div className='flex gap-2'>
              <ModalTextField
                label='OpEx $'
                name='rD'
                value={rD ? rD : ''}
                onChange={onRDChange}
                character={revenue ? '$' : ''}
                isPrefixCharacter={!!revenue}
                isNumber
                placeholder={revenue ? '0' : 'N/A'}
                disabled={!revenue}
                infoIcon={InfoGreyIcon}
                showInfoIcon={!revenue}
                tooltipListTitle='Please enter Revenue in the Required Information to enter a $ amount for OpEx as a % of Revenue'
                labelStyle='text-gray-700'
                containerStyle='gap-[2px]'
                useCommaFormat={true}
              />
              <ModalTextField
                {...rdPercentOpexBaseField}
                label='% of Revenue'
                value={rdPercent ? rdPercent : ''}
                onChange={onRDPercentChange}
                labelStyle='text-gray-700'
                containerStyle='gap-[2px]'
              />
            </div>
          </div>
          <div className='col-start-1'>
            <ModalTextField
              {...cacPaybackField}
              value={CACPaybackPeriod ? CACPaybackPeriod : ''}
              onChange={onCACPaybackPeriodChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationalEfficiencySection;
